export const PE_IMPORT_TEMPLATE_TYPES = "PHYSICAL,HOME_CARE_PE";
export const ROS_IMPORT_TEMPLATE_TYPES = "ROS,HOME_CARE_ROS";
export const HOME_CARE_ROS_TEMPLATE_TYPE: string = "HOME_CARE_ROS";
export const HOME_CARE_PE_TEMPLATE_TYPE: string = "HOME_CARE_PE";
